@if (isLoading()) {
  <h2 class="text-body-lg-500 text-primary-500 mb-2 font-title">Buyer Selections</h2>
  <lib-skeleton variant="fields" [count]="5" [columns]="5" [showHeader]="true" />
} @else if (selections()) {
  <h2 class="text-body-lg-500 text-primary-500 mb-2 font-title">Buyer Selections</h2>

  <div class="border border-slate-200 rounded-md">
    <!-- Panel header -->
    <div class="flex items-center justify-between p-4">
      <span class="text-body-600 text-slate-700">Unit Details</span>
      <div class="flex items-center gap-2">
        <span class="text-body-sm text-primary-500">Total:</span>
        <span class="text-body-700 text-emerald-700">{{ fmt(selections()!.total) }}</span>
      </div>
    </div>

    <!-- Panel content: 5-column data row -->
    <div class="px-4 pb-4">
      <div class="grid grid-cols-2 sm:!grid-cols-3 lg:!grid-cols-4 xl:!grid-cols-5 gap-x-4 gap-y-5">
        <div class="flex flex-col gap-0.5">
          <span class="text-body-xs text-slate-700 uppercase tracking-wider">Base Price</span>
          <span class="text-body-500 text-slate-700">{{ fmt(selections()!.baseModelPrice) }}</span>
        </div>
        <div class="flex flex-col gap-0.5">
          <span class="text-body-xs text-slate-700 uppercase tracking-wider">Unit Premium</span>
          <span class="text-body-500 text-slate-700">{{ fmt(selections()!.unitPremiumPrice) }}</span>
        </div>
        <div class="flex flex-col gap-0.5">
          <span class="text-body-xs text-slate-700 uppercase tracking-wider">In Contract Options</span>
          <span class="text-body-500 text-slate-700">{{ fmt(selections()!.inContractOptions) }}</span>
        </div>
        <div class="flex flex-col gap-0.5">
          <span class="text-body-xs text-slate-700 uppercase tracking-wider">Pending Options</span>
          <span class="text-body-500 text-slate-700">{{ fmt(selections()!.pendingOptions) }}</span>
        </div>
        <div class="flex flex-col gap-0.5">
          <span class="text-body-xs text-slate-700 uppercase tracking-wider">Total Options</span>
          <span class="text-body-500 text-slate-700">{{ fmt(selections()!.totalOptions) }}</span>
        </div>
      </div>
    </div>
  </div>
} @else {
  <p class="text-body-sm text-slate-400 text-center py-6">Buyer selection data not available.</p>
}
